import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: {},
  loading: false,
  error:{}
}

export const EventSlugSlice = createSlice({
  name: 'EventSlug',
  initialState,
  reducers: {
    EventSlug_request: (state, action) => {
      state.value = {};
      state.loading = true;
    },
    EventSlug_success: (state, action) => {

      state.value = action.payload;
      state.loading = false;
      state.error = {};

    },
    EventSlug_failure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.value = {};
    },
    Clear_EventSlug_Details: (state, action) => {
      state.value = {}
      state.error = {};
      state.loading = false;
    },
  }
})

// Action creators are generated for each case reducer function
export const { EventSlug_request, EventSlug_success, EventSlug_failure, Clear_EventSlug_Details } = EventSlugSlice.actions

export default EventSlugSlice.reducer